import React from 'react';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Alert from '@cloudscape-design/components/alert';
import Button from '@cloudscape-design/components/button';
import AuthCard from '../components/AuthCard';

interface RequestReceivedScreenProps {
    email: string;
    onBackToLogin: () => void;
}

/**
 * Shown after an onboarding request is submitted. There's no password/email-
 * verification step here — the user waits for an approver. Once approved, the
 * account is created in IdPrism and the user signs in with their email via
 * "Supplier sign in" (IdPrism prompts for a one-time code and lets them set
 * their own password on first sign-in).
 */
export default function RequestReceivedScreen({
    email,
    onBackToLogin,
}: RequestReceivedScreenProps) {
    return (
        <AuthCard title="Request received" subtitle="We'll be in touch">
            <SpaceBetween size="l">
                <Alert type="success">
                    Thanks — your request for <strong>{email}</strong> has been received. Once an
                    administrator approves it, you&apos;ll be able to sign in with your email using
                    &quot;Supplier sign in&quot;.
                </Alert>
                <Button variant="primary" onClick={onBackToLogin}>
                    Back to sign in
                </Button>
            </SpaceBetween>
        </AuthCard>
    );
}
